import React, { useContext } from 'react';

import cx from 'classnames';

import { XingFrameContext } from '@xingternal/xing-frame-provider';

import { Button, ButtonProps } from '@xingternal/button'; // eslint-disable-line
import { IconEdit } from '@xingternal/icons';

import styles from './EditButton.css';

type EditButtonProps = ButtonProps & {
  showIcon?: boolean;
  ariaLabel?: string;
};

const isIconVisible = (showIcon?: boolean): any => showIcon && IconEdit;

const EditButton = ({
  children,
  showIcon,
  className,
  ariaLabel,
  ...props
}: EditButtonProps) => {
  const { featureSwitches } = useContext(XingFrameContext);

  const canEditMobile = featureSwitches?.includes('ep_mobileEdit');
  return (
    <Button
      className={cx(
        styles.button,
        { [styles.mobileButton]: canEditMobile },
        className
      )}
      icon={isIconVisible(showIcon)}
      {...props}
      aria-label={ariaLabel || 'Edit'}
    >
      {children}
    </Button>
  );
};

export default EditButton;
